import { Cell } from 'react-table';
import type {
  IScheduledPaymentRequest,
  RecurrenceFrequency,
  ScheduledPaymentRequestStatus,
} from '../types';

export const scheduledPaymentRequestStatusTabs: {
  value: ScheduledPaymentRequestStatus;
  label: string;
}[] = [
  { value: 'PENDING', label: 'Pending' },
  { value: 'APPROVED', label: 'Approved' },
  { value: 'DECLINED', label: 'Declined' },
];

export const scheduledPaymentRequestStatusPill: Record<
  ScheduledPaymentRequestStatus,
  string
> = {
  PENDING: 'bg-warning-50 text-warning-600',
  APPROVED: 'bg-success-50 text-success-800',
  DECLINED: 'bg-error-50 text-error-300',
};

export const scheduledPaymentRequestStatusLabel: Record<
  ScheduledPaymentRequestStatus,
  string
> = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  DECLINED: 'Declined',
};

export const recurrenceFrequencyLabel: Record<RecurrenceFrequency, string> = {
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
};

export const scheduledPaymentRequestsColumns = [
  {
    Header: 'Company',
    accessor: 'companyName',
    Cell: ({ row }: Cell) => (
      <span className="text-sm medium text-text">
        {(row.original as IScheduledPaymentRequest & { companyName: string })
          .companyName}
      </span>
    ),
  },
  {
    Header: 'Frequency',
    accessor: 'frequencyLabel',
  },
  {
    Header: 'Additional email',
    accessor: 'additionalEmail',
  },
  {
    Header: 'Requested',
    accessor: 'createdAtDisplay',
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: ({ row }: Cell) => {
      const r = row.original as IScheduledPaymentRequest;
      return (
        <span
          className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs medium ${scheduledPaymentRequestStatusPill[r.status]}`}
        >
          {scheduledPaymentRequestStatusLabel[r.status]}
        </span>
      );
    },
  },
];
